import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },
  backgroundContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
    height: 280,
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    maxWidth: 600,
    height: 280,
  },
  overlayContent: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    fontSize: 11,
    color: 'white',
    padding: 4,
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    marginTop: 10,
  },
  subtitle: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'extrabold',
    marginTop: 10,
  },
  lineBar: {
    borderTop: '4px solid white',
    width: 130,
    marginTop: 20,
  },

  contentWrapper: {
    marginTop: 40,
    marginLeft: 53,
    marginRight: 53,
  },
  boldText: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontWeight: 'extrabold',
    marginBottom: 2,
  },
  text: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontWeight: 'thin',
  },
  contactGrid: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 20,
  },
  gridItem: {
    width: '47%',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contentBox: {
    width: '100%',
    height: 140,
    border: '1px solid #ccc',
    padding: 10,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },

  roundedIconWrapper: {
    marginBottom: 10,
    maxWidth: 60,
    maxHeight: 60,
    width: 60,
    height: 60,
  },
  roundedIcon: {
    width: 60,
    height: 60,
    objectFit: 'fill',
  },
  contentText: {
    fontSize: 11,
    textAlign: 'center',
  },
  fullWidthButton: {
    marginTop: 8,
    width: '100%',
    paddingVertical: 8,
    backgroundColor: '#000',
    alignItems: 'center',
    borderRadius: 4,
  },
  buttonText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 700,
    textDecoration: 'none',
  },
});
